var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"signature-container",style:(("width: " + _vm.width + "px; height: " + _vm.height + "px;"))},[_c('div',{staticClass:"safe-area",style:(("margin: 0 " + (_vm.safeArea[0]) + "px " + (_vm.safeArea[1]) + "px " + (_vm.safeArea[0]) + "px;"))}),_vm._v(" "),_c('canvas',{ref:"signature"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f348213","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/dobrodelen/SignaturePad.vue
// module id = 136
// module chunks = 1 3